import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { EntityItemEntity } from '../components/entity-list/entity-item.entity';
import { EntityListEntity } from '../components/entity-list/entity-list.entity';
import { EntitySliceKey, EntityOriginalSliceState } from './entity.state';
import { EntityRootState, featureSelector } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[EntitySliceKey]
);

const listLoadingSelector = createSelector(
	baseSelector,
	(state) => state.loading
);

const actionInProgressSelector = createSelector(
	baseSelector,
	(state) => state.actionInProgress
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const entityById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class EntitySelector {
	public constructor(private readonly store: Store<EntityRootState>) {}

	private get state(): Observable<EntityOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.store.pipe(select(listLoadingSelector));
	}

	public getActionInProgress$(): Observable<boolean> {
		return this.store.pipe(select(actionInProgressSelector));
	}

	public getEntityList$(): Observable<EntityListEntity> {
		return this.store.pipe(select(listSelector));
	}

	public getEntity$(id: number): Observable<EntityItemEntity | undefined> {
		return this.store.pipe(select(entityById(id)));
	}

	public getSelectedEntities$(
		selected: Array<string>
	): Observable<Array<EntityItemEntity>> {
		return this.getEntityList$().pipe(
			map((list) =>
				selected.reduce<Array<EntityItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
